import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PriceListPanel from "./PriceListPanel";
import * as revaThunks from "../../../redux/thunks/revaThunks";
import * as tournamentThunks from "../../../redux/thunks/tournamentThunks";

const PriceListContainer = ({
    tournaments,
    priceLists,
    loadPriceList,
    savePriceItem,
    deletePriceItem,
    copyPriceList,
    loadAllTournaments,
    match,
    loadingReva,
    loadingTournaments,
}) => {
    const organizerId = match.params.organizerId;

    useEffect(() => {
        const loadAll = async () => {
            await loadAllTournaments(0, 1000, organizerId);
        };
        loadAll();
    }, [organizerId]);

    // Load price lists for all tournaments once they are loaded
    useEffect(() => {
        if (tournaments && tournaments.length > 0) {
            tournaments.forEach(t => {
                if (!priceLists[t.id]) {
                    loadPriceList(t.id);
                }
            });
        }
    }, [tournaments]);

    return (
        <PriceListPanel
            tournaments={tournaments}
            priceLists={priceLists}
            loadPriceList={loadPriceList}
            savePriceItem={savePriceItem}
            deletePriceItem={deletePriceItem}
            copyPriceList={copyPriceList}
            loadingReva={loadingReva}
            loadingTournaments={loadingTournaments}
        />
    );
};

const mapState = (state) => ({
    priceLists: state.reva.priceLists,
    tournaments: state.tournament.all,
    loadingReva: state.loading.reva || {},
    loadingTournaments: state.loading.tournament || {},
});

const mapDispatch = (dispatch) => ({
    loadPriceList: (tid) => dispatch(revaThunks.loadPriceList(tid)),
    savePriceItem: (data) => dispatch(revaThunks.savePriceItem(data)),
    deletePriceItem: (id) => dispatch(revaThunks.deletePriceItem(id)),
    copyPriceList: (from, to) => dispatch(revaThunks.copyPriceList(from, to)),
    loadAllTournaments: (p, ps, oid) => dispatch(tournamentThunks.loadAllTournaments(p, ps, oid)),
});

export default withRouter(connect(mapState, mapDispatch)(PriceListContainer));
